(function() {
  // ── Stap 1: Wrap specifieke zinnen in .bmd-iwt .rte met <mark> tags ──
  // Shopify staat <mark> niet toe in rich text velden, dus doen we het via JS.
  // Langere zinnen EERST — voorkomt dat deelzinnen dubbel gematcht worden.
  var phrases = [
    'sans avoir recours \u00e0 un professionnel',
    'sans gros travaux ni artisans',
    'rapidement et sans effort',
    'directement sur l\u2019ancien carrelage',
    'directement sur l\'ancien carrelage',
    'design moderne, chaleur naturelle et confort acoustique',
    '\u00e9l\u00e9gant, 100\u00a0% \u00e9tanche et facile \u00e0 poser',
    '\u00e9l\u00e9gant, 100 % \u00e9tanche et facile \u00e0 poser',
    'sans gros travaux'
  ];

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function wrapPhrasesInElement(el) {
    var html = el.innerHTML;
    phrases.forEach(function(phrase) {
      // Sla over als al gewrapped
      if (html.indexOf('<mark>' + phrase) !== -1) return;
      var regex = new RegExp('(' + escapeRegex(phrase) + ')', 'g');
      html = html.replace(regex, '<mark>$1</mark>');
    });
    el.innerHTML = html;
  }

  // Wrap in alle .bmd-iwt .rte elementen
  var rteElements = document.querySelectorAll('.bmd-iwt .rte');
  rteElements.forEach(function(el) {
    wrapPhrasesInElement(el);
  });

  // ── Stap 2: Highlight animatie voor <mark> tags en .bmd-highlight elementen ──
  var marks = document.querySelectorAll('.bmd-iwt mark, .bmd-iwt .bmd-highlight');
  // Fade/slide animatie elementen
  var animElements = document.querySelectorAll('.bmd-fade-in, .bmd-slide-left, .bmd-slide-right');

  if (!('IntersectionObserver' in window)) {
    // Fallback: toon alles direct
    marks.forEach(function(m) { m.classList.add('bmd-highlighted'); });
    animElements.forEach(function(el) { el.classList.add('bmd-visible'); });
    return;
  }

  var highlightObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        setTimeout(function() {
          entry.target.classList.add('bmd-highlighted');
        }, 150);
        highlightObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  var animObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('bmd-visible');
        animObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  marks.forEach(function(m) { highlightObserver.observe(m); });
  animElements.forEach(function(el) { animObserver.observe(el); });
})();
